import React from 'react';
import AdminToggle from './AdminToggle';
import { coerceSiteSettingBool } from '../siteSettingsDefaults';

export default function AdminSiteAnnouncementFields({ form, setField }) {
  return (
    <div className="card border shadow-sm mb-3">
      <div className="card-header py-2">
        <h2 className="h6 mb-0">Home announcement bar</h2>
        <p className="small text-muted mb-0 mt-1">
          Site → Home sections tab (this tab). Shown above the home hero. Click Save site settings when done.
        </p>
      </div>
      <div className="card-body">
        <AdminToggle
          id="site-announce-enabled"
          className="mb-3"
          label="Show announcement on home page"
          checked={coerceSiteSettingBool(form.announcement_enabled, false)}
          onChange={(v) => setField('announcement_enabled', v)}
          labelClassName=""
        />
        <label className="form-label" htmlFor="site-announce-text">
          Message
        </label>
        <textarea
          id="site-announce-text"
          className="form-control"
          rows={2}
          maxLength={500}
          value={form.announcement_text || ''}
          onChange={(e) => setField('announcement_text', e.target.value)}
          disabled={!form.announcement_enabled}
          placeholder="e.g. Free shipping on orders over ₹999 this week"
        />
        <div className="mt-3">
          <label className="form-label" htmlFor="site-announce-link">
            Optional link URL
          </label>
          <input
            id="site-announce-link"
            type="text"
            className="form-control"
            value={form.announcement_link || ''}
            onChange={(e) => setField('announcement_link', e.target.value)}
            placeholder="/shop or https://…"
            disabled={!form.announcement_enabled}
          />
          <div className="form-text">Use a site path (/shop) or full https:// link.</div>
        </div>
      </div>
    </div>
  );
}
